//=> https://developers.google.com/analytics/devguides/collection/ga4/reference/events#purchase

class PurchaseCheckoutEventListener {
    // Language: javascript
    // Path: PurchaseCheckoutEventListener.js
    // Compare this snippet from EventListener.js:

    get CheckoutProducts() {
        return ".gtm-checkout-products";
    }

    get DefaultEventName() {
        return "click";
    }

    constructor(element, eventName = this.DefaultEventName) {
        this.element = element;
        this.eventName = eventName;
    }

    callback() {
        const dataLayer = new DataLayer();
        dataLayer.clear();
        var items = [];
        var element = document.querySelector(".gtm-payment-success");

        if (element && element.dataset) {
            var paymentSuccess = element.dataset.payment;
            if (paymentSuccess) {
                var paymentSuccessData = JSON.parse(paymentSuccess);
                for (const paymentProducts of paymentSuccessData.products) {
                    var analyticsData = paymentProducts.Analytics
                        ? JSON.parse(paymentProducts.Analytics)
                        : null;

                    if (analyticsData) {
                        var analticsDataProducts = analyticsData.products
                            ? analyticsData.products[0]
                            : null;

                        var price = Number(
                            analticsDataProducts.price.replace(",", ".")
                        ).toFixed(2);
                        var pricewithdiscount = Number(
                            analticsDataProducts.pricewithdiscount.replace(
                                ",",
                                "."
                            )
                        ).toFixed(2);

                        var item = {
                            item_id: analticsDataProducts.code,
                            item_name: analticsDataProducts.name,
                            affiliation: element.dataset.affiliation,
                            item_brand: analticsDataProducts.brand,
                            item_category: analticsDataProducts.category,
                            currency: analticsDataProducts.currency,
                            price: pricewithdiscount,
                            quantity: paymentProducts.Quantity,
                        };

                        if (analticsDataProducts.categories) {
                            var splitCategories =
                                analticsDataProducts.categories.split(";");
                            for (var j = 0; j < splitCategories.length; j++) {
                                if (j == 0) {
                                    item["item_category"] = splitCategories[j];
                                } else {
                                    item["item_category" + j] =
                                        splitCategories[j];
                                }
                            }
                        }

                        if (paymentProducts.variant) {
                            var variant = JSON.parse(paymentProducts.variant);
                            if (variant) {
                                item["item_variant"] =
                                    Object.values(variant).join(",");
                            }
                        }

                        if (price != pricewithdiscount) {
                            item["price"] = price;
                            item["discount"] = (
                                price - pricewithdiscount
                            ).toFixed(2);
                        }

                        items.push(item);
                    }
                }

                if (items.length > 0) {
                    SendData(dataLayer);
                }

                function SendData(dataLayer) {
                    dataLayer
                        .push({
                            event: "purchase",
                            ecommerce: {
                                transaction_id:
                                    paymentSuccessData.transaction_id,
                                affiliation: paymentSuccessData.affiliation,
                                value: paymentSuccessData.Total,
                                tax: paymentSuccessData.tax,
                                shipping: paymentSuccessData.shipping,
                                currency: paymentSuccessData.currency,
                                items: items,
                            },
                        })
                        .then(() => {
                            console.log("GTM pushed purchase event");
                        })
                        .catch((error) => {
                            console.warn("GTM error purchase event", error);
                        });

                    if (typeof gtag !== "undefined" && !!gtag) {
                        gtag("event", "purchase", {
                            event_category: "Enhanced Ecommerce",
                            event_label: "purchase",
                            value: paymentSuccessData.Total,
                            currency: paymentSuccessData.currency,
                            transaction_id: paymentSuccessData.transaction_id,
                            affiliation: paymentSuccessData.affiliation,
                            tax: paymentSuccessData.tax,
                            shipping: paymentSuccessData.shipping,
                            items: items,
                        });
                    }
                }
            }
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            PurchaseCheckoutEventListener.prototype.callback
        );
    }
    remove() {
        this.element.removeEventListener(
            this.eventName,
            PurchaseCheckoutEventListener.prototype.callback
        );
    }
}
